import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    handleEdit = () => {
        this.props.context.componentParent.handleEditMedication(this.state.data);
    };

    handleView = () => {
        this.props.context.componentParent.handleEditMedication(this.state.data);
    };

    handleDiscontinue = () => {
        if (window.confirm('Are you sure you want to discontinue this medication?')) {
            this.props.context.componentParent.handleDiscontinueMedication(this.state.data);
        }
    };

    render() {
        const isActive = this.state.data.status === 'active';
        const isDiscontinued = this.state.data.status === 'discontinued';
        
        return (
            <div className="action-buttons">
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>View/Edit</Tooltip>}
                >
                    <button 
                        className="btn btn-sm btn-link p-0 mr-2"
                        onClick={this.handleEdit}
                    >
                        <i className="fas fa-pen text-primary"></i>
                    </button>
                </OverlayTrigger>
                
                {isActive && (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Discontinue</Tooltip>}
                    >
                        <button 
                            className="btn btn-sm btn-link p-0"
                            onClick={this.handleDiscontinue}
                        >
                            <i className="fas fa-stop-circle text-danger"></i>
                        </button>
                    </OverlayTrigger>
                )}
                
                {isDiscontinued && (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Discontinued</Tooltip>}
                    >
                        <span className="text-muted">
                            <i className="fas fa-ban"></i>
                        </span>
                    </OverlayTrigger>
                )}
            </div>
        );
    }
}